var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.expiredMsg)?_c('v-row',{staticClass:"justify-center red--text custom-font subtitle-1 mt-12"},[_vm._v(" Your payment link has been expired ! ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }